import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    // Populate the component parts with theme styles
    return {
        chartTextStyle: {
            ...theme.fonts.default,
        },

        container: {
        },

        indicatorTextStyle: {
            ...theme.fonts.default,
        },

        legendTextStyle: {
            ...theme.fonts.default,
        },

        titleTextStyle: {
            ...theme.fonts.default,
        },

        tooltipTextStyle: {
            ...theme.fonts.default,
            color: '#fff',
        },
    };
};

export default getTheme;
